import {Alert} from 'react-native';

export const showAlert = ({
  title,
  text,
  actionButtons = [{text: 'OK'}],
  opt = {cancelable: true},
}: any) => {
  Alert.alert(title, text, actionButtons, opt);
};
